import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

export function lessThanOrEqualToValidator(lessThanOrEqualToField: string, checkAgainstField: string): ValidatorFn {
	return (group: UntypedFormGroup) => {
		const lessThanField: any = group.get(lessThanOrEqualToField)?.value;
		const checkField: any = group.get(checkAgainstField)?.value;

		if (!lessThanField && !checkField) return null;
		if (isNaN(lessThanField) && !Array.isArray(lessThanField)) return null;
		if (isNaN(checkField) && !Array.isArray(checkField)) return null;

		const lessThanValue: number = Array.isArray(lessThanField) ? lessThanField?.length : +lessThanField;
		const checkValue: number = Array.isArray(checkField) ? checkField?.length : +checkField;

		return lessThanValue <= checkValue ? null : { lessThanOrEqualTo: true };
	};
}
